module.exports = __webpack_public_path__ + "img/image-3.51df0eb2.png";